import PropTypes from 'prop-types';
import CloseIcon from 'mdi-react/CloseIcon';

import styles from './Modal.module.scss';

const Modal = ({
  children,
  color,
  maxWidth,
  maxHeight,
  onDismiss,
  restrictClose,
  showCloseButton,
  closeButtonColor,
  height,
  width,
  isFullScreen,
  isStickToBottom,
  testId,
}) => {
  const onSelfDismiss = restrictClose ? () => undefined : onDismiss;

  return (
    <div className={styles['modal-wrapper']} data-test-id={testId}>
      <div
        className={styles['background']}
        onClick={onSelfDismiss}
        aria-hidden="true"
        role="tab"
        tabIndex={0}
      />
      <div
        className={styles['z-modal']}
        style={{
          backgroundColor: color,
          bottom: isStickToBottom ? 0 : 'auto',
          height: isFullScreen ? '100%' : height,
          left: isStickToBottom ? 'auto' : '50%',
          maxHeight: maxHeight ?? '',
          maxWidth: maxWidth ?? '',
          top: isStickToBottom ? 'auto' : '50%',
          transform: isStickToBottom ? 'none' : 'translate(-50%, -50%)',
          width,
        }}
      >
        <div
          className={styles['z-modal-content']}
          style={{
            height: isFullScreen ? '100%' : height,
          }}
        >
          {showCloseButton && (
            <button
              aria-label="Close"
              className={styles['modal-close-btn']}
              data-test-id="modal-close-btn"
              onClick={onDismiss}
              style={{ color: closeButtonColor }}
            >
              {/* Added span to fix iOS close button disappeared */}
              <span>
                <CloseIcon color={closeButtonColor} size={24} />
              </span>
            </button>
          )}
          {children}
        </div>
      </div>
    </div>
  );
};

Modal.propTypes = {
  children: PropTypes.node,
  closeButtonColor: PropTypes.string,
  color: PropTypes.string,
  height: PropTypes.string,
  isFullScreen: PropTypes.bool,
  isStickToBottom: PropTypes.bool,
  maxHeight: PropTypes.string,
  maxWidth: PropTypes.string,
  onDismiss: PropTypes.func,
  restrictClose: PropTypes.bool,
  showCloseButton: PropTypes.bool,
  testId: PropTypes.string,
  width: PropTypes.string,
};

Modal.defaultProps = {
  children: null,
  closeButtonColor: '#545454',
  color: '#f5f5f5',
  height: '',
  isFullScreen: false,
  isStickToBottom: false,
  maxHeight: 'calc(100% - 30px)',
  maxWidth: '',
  onDismiss: () => null,
  restrictClose: false,
  showCloseButton: true,
  testId: null,
  width: '37.5rem',
};

export default Modal;
